<div class="flex flex-col gap-4">
  <div class="flex justify-end">
    <app-ai-generated-label [provenance]="reasonProvenance()" />
  </div>
  <app-model-field-textarea
    [id]="'decision-reason-' + hrToolDirectusId()"
    label="project.steps.overallResults.decisionReason"
    [value]="reasonText()"
    (valueChange)="onReasonTextChange($event)"
    [rows]="6"
    [isReadOnly]="isReadOnly()"
  ></app-model-field-textarea>

  @if (hasUnsavedChanges()) {
    <div class="flex justify-end gap-2">
      <p-button
        [label]="'project.steps.overallResults.decisionReason.improve' | transloco"
        icon="pi pi-sparkles"
        [loading]="isImproving()"
        (onClick)="improveReason()"
        [attr.data-testid]="'improve-reason-' + hrToolDirectusId()"
      ></p-button>
      <app-project-step-save-button
        [loading]="isSaving()"
        [disabled]="isSaving()"
        (clicked)="saveReason()"
      ></app-project-step-save-button>
    </div>
  }
</div>
